var _ellipse, _g, _g2, _g3, _g4, _ellipse2, _path, _path2, _path3, _path4, _path5, _g5, _ellipse3, _g6, _g7, _ellipse4, _g8, _ellipse5, _g9, _ellipse6, _path6, _path7, _path8, _path9, _path10, _g10, _g11, _g12, _g13, _g14, _ellipse7, _path11, _path12, _path13, _path14, _g15, _path15, _path16, _path17, _path18, _g16, _rect, _g17, _path19, _g18, _path20, _path21, _path22, _path23, _circle, _circle2, _rect2, _rect3, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle3, _circle4, _g19, _g20, _rect4, _g21, _path33, _g22, _path34, _path35, _path36, _path37, _circle5, _circle6, _rect5, _rect6, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _circle7, _circle8, _g23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitPaymentMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 150,
    viewBox: "0 0 228 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5626_19978)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6922,
    cy: 20.6917,
    rx: 20.6922,
    ry: 20.6917,
    transform: "matrix(0.99342 0.114531 -0.114535 0.993419 168.25 101.998)",
    fill: "#EFBA80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.495 107.449C198.174 108.565 205.116 117.316 204 126.994C202.884 136.673 194.133 143.614 184.454 142.498C174.776 141.382 167.834 132.632 168.95 122.954C170.066 113.275 178.817 106.334 188.495 107.449Z",
    stroke: "#BF741E",
    strokeWidth: 1.76855
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.926 115.801C175.93 115.796 175.933 115.789 175.935 115.783C176.055 115.48 176.389 115.36 176.705 115.397L179.003 115.662C179.056 115.668 179.103 115.63 179.109 115.578L179.374 113.279C179.411 112.964 179.603 112.666 179.925 112.618C179.932 112.617 179.939 112.615 179.946 112.613C180.279 112.496 180.585 112.613 180.795 112.877L183.618 116.436C183.759 116.614 183.821 116.783 183.793 117.022L183.466 119.855C183.464 119.88 183.471 119.905 183.486 119.925L187.485 124.966C187.767 125.322 187.712 125.8 187.356 126.083C187.178 126.224 186.93 126.276 186.77 126.258C186.611 126.239 186.381 126.132 186.239 125.954L182.241 120.913C182.225 120.894 182.202 120.881 182.177 120.878L179.344 120.551C179.105 120.524 178.954 120.426 178.813 120.248L175.99 116.689C175.78 116.424 175.736 116.1 175.926 115.801Z",
    fill: "#BF741E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.994 126.943C185.337 127.467 185.948 127.78 186.586 127.854C187.224 127.928 187.89 127.762 188.344 127.329C189.412 126.482 189.587 124.966 188.731 123.978L186.837 121.591C186.796 121.54 186.819 121.466 186.883 121.457C187.031 121.438 187.2 121.458 187.322 121.472C189.556 121.729 191.109 123.687 190.851 125.921C190.594 128.154 188.636 129.707 186.402 129.45C184.168 129.192 182.616 127.235 182.873 125.001C182.887 124.879 182.907 124.71 182.959 124.57C182.982 124.509 183.059 124.504 183.1 124.555L184.994 126.943Z",
    fill: "#BF741E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.567 121.235C177.911 121.76 178.522 122.073 179.16 122.146L181.355 122.399C181.38 122.402 181.403 122.415 181.418 122.435L181.848 122.976C181.872 123.007 181.875 123.049 181.856 123.083C181.573 123.602 181.428 124.209 181.357 124.825C180.998 127.936 183.187 130.694 186.298 131.053C189.409 131.412 192.168 129.224 192.526 126.112C192.885 123.001 190.697 120.243 187.586 119.884C186.965 119.812 186.326 119.892 185.761 119.984C185.731 119.989 185.701 119.98 185.679 119.959L185.166 119.472C185.144 119.452 185.133 119.422 185.136 119.392L185.388 117.206C185.462 116.567 185.296 115.902 184.864 115.447L184.25 114.674C184.207 114.62 184.234 114.539 184.302 114.523C185.584 114.22 186.842 114.14 188.15 114.29C194.293 114.999 198.739 120.604 198.031 126.747C197.323 132.89 191.717 137.336 185.574 136.628C179.431 135.92 174.985 130.315 175.693 124.172C175.844 122.864 176.208 121.657 176.795 120.478C176.826 120.416 176.911 120.407 176.954 120.462L177.567 121.235Z",
    fill: "#BF741E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5626_19978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 104,
    width: 43,
    height: 42
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6922,
    cy: 20.6917,
    rx: 20.6922,
    ry: 20.6917,
    transform: "matrix(0.99342 0.114531 -0.114535 0.993419 168.327 102.096)",
    fill: "#EFBA80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.572 107.547C198.251 108.663 205.193 117.413 204.077 127.092C202.961 136.771 194.21 143.712 184.531 142.596C174.852 141.48 167.911 132.73 169.027 123.051C170.143 113.373 178.893 106.431 188.572 107.547Z",
    stroke: "#8C5B24",
    strokeWidth: 1.76855
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.32 137.685C185.314 137.738 185.354 137.786 185.408 137.79C190.041 138.119 194.154 134.741 194.691 130.082C194.716 129.868 194.733 129.654 194.742 129.442L195.796 120.298C195.805 120.217 195.716 120.162 195.649 120.207L192.53 122.25C192.48 122.282 192.412 122.262 192.389 122.206L188.397 112.565C188.359 112.474 188.225 112.493 188.213 112.59L187.71 116.959C187.708 116.975 187.71 116.991 187.716 117.006L191.314 125.694C191.337 125.749 191.405 125.77 191.455 125.737L192.767 124.877C192.835 124.833 192.923 124.888 192.914 124.968L192.419 129.264L192.417 129.309C192.411 129.477 192.398 129.646 192.379 129.815C191.988 133.2 189.025 135.662 185.667 135.474C185.616 135.471 185.571 135.508 185.565 135.559L185.32 137.685Z",
    fill: "#8C5B24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.673 134.625C185.667 134.68 185.708 134.729 185.763 134.731C188.234 134.815 190.396 132.987 190.684 130.487C190.821 129.298 190.51 128.158 189.885 127.24C189.882 127.235 189.878 127.229 189.876 127.223L187.397 121.237C187.359 121.146 187.225 121.164 187.214 121.262L186.71 125.631C186.708 125.647 186.71 125.663 186.717 125.678L187.827 128.36C187.83 128.367 187.834 128.374 187.839 128.38L187.914 128.483C188.268 128.968 188.446 129.578 188.372 130.22C188.23 131.447 187.212 132.36 186.014 132.404C185.965 132.405 185.925 132.442 185.919 132.49L185.673 134.625Z",
    fill: "#8C5B24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.268 132.318C185.315 132.33 185.347 132.375 185.341 132.423L185.095 134.559C185.088 134.613 185.037 134.651 184.983 134.641C182.557 134.16 180.868 131.888 181.157 129.388C181.294 128.199 181.857 127.16 182.674 126.409C182.678 126.404 182.683 126.399 182.687 126.394L186.463 121.129C186.52 121.049 186.647 121.098 186.635 121.196L186.132 125.564C186.13 125.58 186.124 125.596 186.115 125.609L184.423 127.968C184.418 127.974 184.413 127.98 184.407 127.985L184.31 128.068C183.856 128.459 183.543 129.013 183.469 129.655C183.328 130.882 184.112 132.003 185.268 132.318Z",
    fill: "#8C5B24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.132 116.892C187.13 116.908 187.124 116.924 187.114 116.937L181.625 124.59C181.59 124.639 181.52 124.643 181.479 124.6L180.382 123.449C180.326 123.391 180.227 123.424 180.218 123.504L179.66 128.349C179.269 131.733 181.595 134.805 184.907 135.386C184.958 135.395 184.993 135.442 184.987 135.492L184.742 137.618C184.736 137.671 184.686 137.709 184.633 137.701C180.047 136.967 176.81 132.742 177.347 128.082L178.475 118.301C178.484 118.22 178.583 118.187 178.639 118.246L181.225 120.96C181.266 121.003 181.337 120.998 181.372 120.949L187.463 112.457C187.52 112.377 187.647 112.426 187.635 112.524L187.132 116.892Z",
    fill: "#8C5B24"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5626_19978)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -3.53709,
    x2: 46.0893,
    y2: -3.53709,
    transform: "matrix(0.917598 -0.397513 0.397529 0.917588 167.306 132.566)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 7.07418
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -1.41484,
    x2: 46.0893,
    y2: -1.41484,
    transform: "matrix(0.917598 -0.397513 0.397529 0.917588 170.767 138.691)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2.82967
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_5626_19978)"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.8135,
    cy: 22.8127,
    rx: 22.8135,
    ry: 22.8127,
    transform: "matrix(0.965926 -0.258817 0.258822 0.965925 171.5 11.834)",
    fill: "#FFDD53"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.466 9.20972C204.842 6.4295 215.508 12.5871 218.288 22.9629C221.068 33.3385 214.91 44.0034 204.534 46.7836C194.158 49.5636 183.493 43.4066 180.712 33.0312C177.932 22.6556 184.09 11.9901 194.466 9.20972Z",
    stroke: "#CF9A09",
    strokeWidth: 1.95043
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5626_19978)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5626_19978)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.065 22.0012C207.637 20.4019 206.813 18.9365 205.667 17.7413C204.522 16.546 203.093 15.6596 201.513 15.1644C199.933 14.6692 198.254 14.5812 196.631 14.9086C195.009 15.2361 193.495 15.9683 192.231 17.0374C190.967 18.1064 189.993 19.4776 189.401 21.0235C188.809 22.5694 188.617 24.2399 188.843 25.8799C189.069 27.5199 189.706 29.0761 190.694 30.404C191.683 31.732 192.991 32.7885 194.497 33.4756L196.698 41.6888C196.737 41.836 196.814 41.9706 196.92 42.08C197.026 42.1893 197.158 42.2697 197.304 42.3136C197.45 42.3574 197.604 42.3632 197.753 42.3304C197.902 42.2977 198.04 42.2274 198.154 42.1263L202.303 38.4535L207.736 39.5646C207.871 39.5899 208.011 39.5838 208.143 39.5467C208.372 39.4854 208.567 39.3357 208.686 39.1306C208.804 38.9254 208.836 38.6817 208.775 38.4529L206.574 30.2397C207.415 29.0616 207.985 27.7119 208.243 26.2875C208.501 24.8631 208.44 23.3993 208.065 22.0012ZM190.812 26.624C190.401 25.0885 190.454 23.4655 190.965 21.9602C191.476 20.4549 192.422 19.1349 193.683 18.1672C194.944 17.1995 196.464 16.6275 198.05 16.5235C199.637 16.4195 201.218 16.7883 202.595 17.5831C203.971 18.3779 205.081 19.5631 205.785 20.9889C206.488 22.4146 206.752 24.0168 206.545 25.5928C206.337 27.1689 205.667 28.648 204.619 29.8432C203.571 31.0383 202.192 31.8959 200.656 32.3073C198.597 32.8565 196.404 32.5666 194.559 31.5012C192.714 30.4357 191.366 28.6817 190.812 26.624ZM192.538 26.1617C192.218 24.9674 192.259 23.7051 192.656 22.5343C193.054 21.3635 193.789 20.3369 194.77 19.5842C195.751 18.8315 196.933 18.3866 198.167 18.3058C199.401 18.2249 200.631 18.5117 201.702 19.1299C202.772 19.7481 203.636 20.6699 204.183 21.7788C204.73 22.8877 204.935 24.1339 204.774 25.3597C204.612 26.5855 204.091 27.7359 203.276 28.6655C202.461 29.5951 201.388 30.2621 200.194 30.5821C198.593 31.0093 196.887 30.7839 195.452 29.9551C194.016 29.1264 192.968 27.7622 192.538 26.1617Z",
    fill: "#CF9A09"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5626_19978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 5,
    width: 47,
    height: 46
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.8135,
    cy: 22.8127,
    rx: 22.8135,
    ry: 22.8127,
    transform: "matrix(0.965926 -0.258817 0.258822 0.965925 171.619 11.9004)",
    fill: "#EFBA80"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5626_19978)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -3.89968,
    x2: 50.8141,
    y2: -3.89968,
    transform: "matrix(0.707117 -0.707093 0.70712 0.707097 182.926 43.5527)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 7.79936
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -1.55987,
    x2: 50.8141,
    y2: -1.55987,
    transform: "matrix(0.707117 -0.707093 0.70712 0.707097 188.957 48.4277)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3.11974
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_5626_19978)"
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.2798,
    cy: 27.28,
    rx: 27.2798,
    ry: 27.28,
    transform: "matrix(0.965925 0.258822 -0.258816 0.965927 14.6523 1.99805)",
    fill: "#E4E4E4"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0036 13.0134C52.4107 16.338 59.7737 29.0912 56.4494 41.4984C53.1249 53.9058 40.3716 61.2696 27.9644 57.9451C15.5572 54.6204 8.19433 41.8664 11.5188 29.4591C14.8434 17.0521 27.5965 9.68904 40.0036 13.0134Z",
    stroke: "#7A7A7A",
    strokeWidth: 2.33162
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5626_19978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 56,
    height: 55
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.2798,
    cy: 27.28,
    rx: 27.2798,
    ry: 27.28,
    transform: "matrix(0.965925 0.258822 -0.258816 0.965927 14.7349 2.14453)",
    fill: "#EFBA80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0846 13.1619C52.4918 16.4864 59.8547 29.2396 56.5305 41.6469C53.206 54.0542 40.4527 61.4181 28.0454 58.0935C15.6383 54.7689 8.27538 42.0149 11.5999 29.6076C14.9245 17.2005 27.6776 9.83748 40.0846 13.1619Z",
    stroke: "#8C5B24",
    strokeWidth: 2.33162
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0242 51.8386C30.0058 51.9073 30.0485 51.9778 30.1179 51.9932C36.0965 53.3167 42.1131 49.7062 43.7135 43.7331C43.7871 43.4586 43.8501 43.1835 43.9028 42.9082L47.0437 31.1858C47.0714 31.0827 46.9662 30.9942 46.8693 31.039L42.4076 33.1011C42.336 33.1342 42.2519 33.0939 42.2327 33.0174L38.8874 19.672C38.8558 19.546 38.6772 19.5446 38.6436 19.6701L37.1431 25.2702C37.1375 25.2909 37.1374 25.3126 37.1426 25.3334L40.1568 37.3578C40.176 37.4343 40.2601 37.4745 40.3317 37.4414L42.209 36.5738C42.3059 36.529 42.4111 36.6175 42.3835 36.7206L40.9079 42.2275L40.897 42.2864C40.8566 42.5036 40.8074 42.7212 40.7491 42.9388C39.5866 47.2775 35.2466 49.9164 30.9036 49.0228C30.8377 49.0092 30.7717 49.0488 30.7543 49.1139L30.0242 51.8386Z",
    fill: "#8C5B24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.075 47.917C31.0562 47.987 31.1007 48.0586 31.172 48.0716C34.379 48.6585 37.5512 46.6919 38.4098 43.4875C38.8183 41.9629 38.6321 40.416 37.9947 39.099C37.9909 39.0912 37.988 39.083 37.9858 39.0745L35.9087 30.7887C35.8771 30.6627 35.6986 30.6612 35.665 30.7867L34.1645 36.3867C34.1589 36.4074 34.1587 36.4291 34.164 36.4499L35.0946 40.1625C35.0971 40.1722 35.1006 40.1815 35.1053 40.1904L35.1836 40.3395C35.5514 41.0396 35.6659 41.8701 35.4454 42.6932C35.0239 44.2661 33.519 45.2595 31.9487 45.0854C31.8852 45.0783 31.8251 45.1176 31.8085 45.1793L31.075 47.917Z",
    fill: "#8C5B24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.993 44.8293C31.0515 44.8549 31.084 44.919 31.0674 44.9807L30.3339 47.7184C30.3151 47.7884 30.2408 47.8282 30.1726 47.8038C27.1018 46.7085 25.3378 43.4193 26.1964 40.2149C26.605 38.6903 27.5398 37.4437 28.7502 36.6219C28.7574 36.617 28.7641 36.6114 28.7701 36.6051L34.7118 30.468C34.8021 30.3747 34.9575 30.4627 34.9238 30.5882L33.4233 36.1882C33.4178 36.2089 33.4071 36.2278 33.3922 36.2432L30.73 38.9929C30.7231 39.0001 30.7153 39.0064 30.7068 39.0118L30.5644 39.1018C29.8959 39.5241 29.3814 40.1862 29.1608 41.0093C28.7394 42.5822 29.546 44.1949 30.993 44.8293Z",
    fill: "#8C5B24"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.402 25.0716C36.3964 25.0923 36.3857 25.1112 36.3708 25.1266L27.7345 34.0472C27.6796 34.104 27.5866 34.0967 27.5411 34.0322L26.3334 32.3198C26.2719 32.2326 26.1365 32.2567 26.1089 32.3598L24.4449 38.57C23.2823 42.9088 25.7214 47.3641 29.9294 48.7617C29.9933 48.7829 30.0306 48.8502 30.0132 48.9153L29.2831 51.64C29.2647 51.7087 29.1925 51.7484 29.1246 51.727C23.2852 49.8839 19.88 43.7488 21.4805 37.7757L24.8403 25.2364C24.868 25.1333 25.0033 25.1092 25.0649 25.1964L27.9135 29.2354C27.959 29.2999 28.0519 29.3071 28.1068 29.2504L37.6904 19.3513C37.7808 19.258 37.9361 19.346 37.9025 19.4715L36.402 25.0716Z",
    fill: "#8C5B24"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5626_19978)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -4.66323,
    x2: 60.7628,
    y2: -4.66323,
    transform: "matrix(0.965923 -0.25882 0.258818 0.965929 7.51807 41.6855)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 9.32647
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -1.86529,
    x2: 60.7628,
    y2: -1.86529,
    transform: "matrix(0.965923 -0.25882 0.258818 0.965929 10.8472 50.3359)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3.73059
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9402 51.6999C29.9218 51.7686 29.9645 51.8391 30.0339 51.8545C36.0126 53.178 42.0291 49.5675 43.6295 43.5944C43.7031 43.3199 43.7661 43.0448 43.8188 42.7695L46.9598 31.0472C46.9874 30.9441 46.8822 30.8555 46.7853 30.9003L42.3236 32.9624C42.252 32.9955 42.1679 32.9553 42.1487 32.8787L38.8034 19.5334C38.7718 19.4074 38.5932 19.4059 38.5596 19.5314L37.0591 25.1315C37.0536 25.1522 37.0534 25.1739 37.0586 25.1947L40.0728 37.2191C40.092 37.2956 40.1761 37.3359 40.2477 37.3028L42.1251 36.4351C42.222 36.3903 42.3271 36.4789 42.2995 36.582L40.824 42.0888L40.813 42.1477C40.7726 42.3649 40.7234 42.5825 40.6651 42.8001C39.5026 47.1389 35.1627 49.7778 30.8196 48.8841C30.7537 48.8705 30.6877 48.9101 30.6703 48.9752L29.9402 51.6999Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.991 47.7783C30.9722 47.8483 31.0167 47.9199 31.088 47.9329C34.295 48.5198 37.4672 46.5533 38.3258 43.3489C38.7343 41.8243 38.5481 40.2773 37.9107 38.9603C37.907 38.9525 37.904 38.9443 37.9019 38.9359L35.8247 30.65C35.7931 30.524 35.6146 30.5225 35.581 30.648L34.0805 36.248C34.0749 36.2687 34.0748 36.2905 34.08 36.3112L35.0106 40.0238C35.0131 40.0335 35.0167 40.0429 35.0213 40.0517L35.0996 40.2009C35.4674 40.9009 35.5819 41.7315 35.3614 42.5546C34.9399 44.1275 33.4351 45.1208 31.8647 44.9467C31.8013 44.9397 31.7411 44.9789 31.7245 45.0406L30.991 47.7783Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.909 44.6906C30.9675 44.7163 31 44.7803 30.9834 44.842L30.2499 47.5797C30.2311 47.6498 30.1569 47.6895 30.0886 47.6651C27.0178 46.5699 25.2539 43.2807 26.1125 40.0763C26.521 38.5516 27.4558 37.305 28.6662 36.4832C28.6734 36.4783 28.6801 36.4727 28.6861 36.4664L34.6278 30.3293C34.7181 30.236 34.8735 30.324 34.8399 30.4495L33.3394 36.0495C33.3338 36.0702 33.3231 36.0891 33.3082 36.1045L30.646 38.8542C30.6391 38.8614 30.6313 38.8678 30.6228 38.8731L30.4804 38.9631C29.8119 39.3855 29.2974 40.0475 29.0769 40.8706C28.6554 42.4435 29.462 44.0562 30.909 44.6906Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.318 24.9329C36.3125 24.9536 36.3017 24.9725 36.2868 24.9879L27.6505 33.9086C27.5956 33.9653 27.5026 33.9581 27.4571 33.8936L26.2494 32.1812C26.1879 32.0939 26.0525 32.118 26.0249 32.2212L24.3609 38.4313C23.1984 42.7701 25.6374 47.2254 29.8454 48.623C29.9093 48.6443 29.9466 48.7116 29.9292 48.7766L29.1991 51.5013C29.1807 51.57 29.1085 51.6098 29.0407 51.5883C23.2013 49.7452 19.796 43.6101 21.3965 37.637L24.7564 25.0977C24.784 24.9946 24.9193 24.9705 24.9809 25.0577L27.8295 29.0967C27.875 29.1612 27.9679 29.1684 28.0228 29.1117L37.6065 19.2127C37.6968 19.1193 37.8521 19.2073 37.8185 19.3328L36.318 24.9329Z",
    fill: "#7A7A7A"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_5626_19978)"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4001,
    cy: 18.4,
    rx: 18.4001,
    ry: 18.4,
    transform: "matrix(0.919635 0.392775 -0.392772 0.919636 33.9541 85.998)",
    fill: "#B290F6"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8309 95.7725C57.7981 99.1755 61.4981 108.392 58.0956 116.36C54.6927 124.327 45.4756 128.028 37.5081 124.625C29.5406 121.222 25.8401 112.004 29.2429 104.037C32.646 96.0695 41.8635 92.3696 49.8309 95.7725Z",
    stroke: "#512D9A",
    strokeWidth: 1.57265
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0007 99.7067C37.0054 99.7026 37.0097 99.698 37.0136 99.6931C37.1925 99.4655 37.5073 99.448 37.7672 99.559L39.6593 100.367C39.7024 100.385 39.7523 100.365 39.7707 100.322L40.5788 98.4302C40.6898 98.1703 40.9294 97.9654 41.216 98.0061C41.2222 98.0069 41.2285 98.0073 41.2347 98.007C41.5487 97.9918 41.7798 98.169 41.8916 98.4474L43.3966 102.196C43.4718 102.384 43.4814 102.543 43.3973 102.74L42.4013 105.072C42.3925 105.093 42.3922 105.116 42.4006 105.137L44.5321 110.446C44.6826 110.821 44.5143 111.215 44.1394 111.366C43.952 111.441 43.7269 111.423 43.5956 111.367C43.4642 111.31 43.2953 111.161 43.22 110.973L41.0885 105.664C41.0801 105.643 41.0638 105.626 41.0431 105.617L38.7112 104.621C38.5142 104.537 38.4109 104.415 38.3356 104.228L36.8306 100.479C36.7189 100.201 36.7634 99.9129 37.0007 99.7067Z",
    fill: "#512D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9073 111.501C42.0674 112.036 42.5086 112.457 43.034 112.681C43.5594 112.906 44.1689 112.933 44.6656 112.679C45.7902 112.228 46.3231 110.98 45.8436 109.921L44.834 107.406C44.8124 107.353 44.8502 107.295 44.9075 107.304C45.0385 107.325 45.1774 107.385 45.2779 107.428C47.1167 108.213 47.9445 110.275 47.1591 112.114C46.3737 113.953 44.3119 114.78 42.473 113.995C40.6342 113.21 39.8064 111.148 40.5918 109.309C40.6347 109.208 40.694 109.07 40.774 108.964C40.8089 108.917 40.8761 108.933 40.8977 108.987L41.9073 111.501Z",
    fill: "#512D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0235 104.756C37.1836 105.29 37.6248 105.711 38.1502 105.936L39.9567 106.707C39.9774 106.716 39.9938 106.733 40.0021 106.754L40.231 107.324C40.2439 107.356 40.2359 107.393 40.2112 107.417C39.8387 107.788 39.5611 108.268 39.3446 108.775C38.2507 111.337 39.4171 114.242 41.9783 115.336C44.5396 116.43 47.4449 115.263 48.5388 112.702C49.6327 110.141 48.4664 107.236 45.9051 106.142C45.3939 105.923 44.8295 105.829 44.3242 105.765C44.2979 105.761 44.2746 105.746 44.2614 105.723L43.9466 105.178C43.9332 105.154 43.9315 105.126 43.942 105.102L44.7107 103.302C44.9351 102.777 44.9625 102.167 44.7087 101.67L44.3816 100.856C44.3585 100.798 44.4025 100.736 44.4642 100.74C45.6334 100.806 46.7267 101.057 47.8028 101.517C52.8597 103.676 55.23 109.581 53.0703 114.638C50.9105 119.694 45.0061 122.065 39.9492 119.905C34.8924 117.745 32.5221 111.841 34.6818 106.784C35.1414 105.708 35.758 104.771 36.5567 103.914C36.5988 103.869 36.6734 103.883 36.6964 103.941L37.0235 104.756Z",
    fill: "#512D9A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5626_19978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 91,
    width: 38,
    height: 38
  }, _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4001,
    cy: 18.4,
    rx: 18.4001,
    ry: 18.4,
    transform: "matrix(0.919635 0.392775 -0.392772 0.919636 33.9541 85.998)",
    fill: "#B290F6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8309 95.7725C57.7981 99.1755 61.4981 108.392 58.0956 116.36C54.6927 124.327 45.4756 128.028 37.5081 124.625C29.5406 121.222 25.8401 112.004 29.2429 104.037C32.646 96.0695 41.8635 92.3696 49.8309 95.7725Z",
    stroke: "#512D9A",
    strokeWidth: 1.57265
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0007 99.7067C37.0054 99.7026 37.0097 99.698 37.0136 99.6931C37.1925 99.4655 37.5073 99.448 37.7672 99.559L39.6593 100.367C39.7024 100.385 39.7523 100.365 39.7707 100.322L40.5788 98.4302C40.6898 98.1703 40.9294 97.9654 41.216 98.0061C41.2222 98.0069 41.2285 98.0073 41.2347 98.007C41.5487 97.9918 41.7798 98.169 41.8916 98.4474L43.3966 102.196C43.4718 102.384 43.4814 102.543 43.3973 102.74L42.4013 105.072C42.3925 105.093 42.3922 105.116 42.4006 105.137L44.5321 110.446C44.6826 110.821 44.5143 111.215 44.1394 111.366C43.952 111.441 43.7269 111.423 43.5956 111.367C43.4642 111.31 43.2953 111.161 43.22 110.973L41.0885 105.664C41.0801 105.643 41.0638 105.626 41.0431 105.617L38.7112 104.621C38.5142 104.537 38.4109 104.415 38.3356 104.228L36.8306 100.479C36.7189 100.201 36.7634 99.9129 37.0007 99.7067Z",
    fill: "#512D9A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9073 111.501C42.0674 112.036 42.5086 112.457 43.034 112.681C43.5594 112.906 44.1689 112.933 44.6656 112.679C45.7902 112.228 46.3231 110.98 45.8436 109.921L44.834 107.406C44.8124 107.353 44.8502 107.295 44.9075 107.304C45.0385 107.325 45.1774 107.385 45.2779 107.428C47.1167 108.213 47.9445 110.275 47.1591 112.114C46.3737 113.953 44.3119 114.78 42.473 113.995C40.6342 113.21 39.8064 111.148 40.5918 109.309C40.6347 109.208 40.694 109.07 40.774 108.964C40.8089 108.917 40.8761 108.933 40.8977 108.987L41.9073 111.501Z",
    fill: "#512D9A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0235 104.756C37.1836 105.29 37.6248 105.711 38.1502 105.936L39.9567 106.707C39.9774 106.716 39.9938 106.733 40.0021 106.754L40.231 107.324C40.2439 107.356 40.2359 107.393 40.2112 107.417C39.8387 107.788 39.5611 108.268 39.3446 108.775C38.2507 111.337 39.4171 114.242 41.9783 115.336C44.5396 116.43 47.4449 115.263 48.5388 112.702C49.6327 110.141 48.4664 107.236 45.9051 106.142C45.3939 105.923 44.8295 105.829 44.3242 105.765C44.2979 105.761 44.2746 105.746 44.2614 105.723L43.9466 105.178C43.9332 105.154 43.9315 105.126 43.942 105.102L44.7107 103.302C44.9351 102.777 44.9625 102.167 44.7087 101.67L44.3816 100.856C44.3585 100.798 44.4025 100.736 44.4642 100.74C45.6334 100.806 46.7267 101.057 47.8028 101.517C52.8597 103.676 55.23 109.581 53.0703 114.638C50.9105 119.694 45.0061 122.065 39.9492 119.905C34.8924 117.745 32.5221 111.841 34.6818 106.784C35.1414 105.708 35.758 104.771 36.5567 103.914C36.5988 103.869 36.6734 103.883 36.6964 103.941L37.0235 104.756Z",
    fill: "#512D9A"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5626_19978)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -3.14531,
    x2: 40.9841,
    y2: -3.14531,
    transform: "matrix(0.992813 -0.119662 0.119669 0.992815 25.4072 111.814)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 6.29061
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -1.25812,
    x2: 40.9841,
    y2: -1.25812,
    transform: "matrix(0.992813 -0.119662 0.119669 0.992815 26.8057 117.91)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2.51625
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.123 75.2817L208.7 69.998L207.173 75.6707L201.5 77.198L206.784 78.6207L210.123 75.2817ZM210.594 75.7695L207.271 79.0922L208.7 84.398L210.227 78.7254L215.9 77.198L210.594 75.7695Z",
    fill: "#512D9A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.123 13.2817L101.7 7.99805L100.173 13.6707L94.5 15.198L99.7836 16.6207L103.123 13.2817ZM103.594 13.7695L100.271 17.0922L101.7 22.398L103.227 16.7254L108.9 15.198L103.594 13.7695Z",
    fill: "#512D9A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1226 75.2817L11.7 69.998L10.1727 75.6707L4.5 77.198L9.78364 78.6207L13.1226 75.2817ZM13.5942 75.7695L10.2714 79.0922L11.7 84.398L13.2274 78.7254L18.9 77.198L13.5942 75.7695Z",
    fill: "#512D9A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1226 124.282L80.7 118.998L79.1727 124.671L73.5 126.198L78.7836 127.621L82.1226 124.282ZM82.5942 124.769L79.2714 128.092L80.7 133.398L82.2274 127.725L87.9 126.198L82.5942 124.769Z",
    fill: "#512D9A"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_5626_19978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.9805,
    y: 56.084,
    width: 80.1,
    height: 44.1,
    rx: 3.6,
    transform: "rotate(-24.6653 64.9805 56.084)",
    fill: "#C9FF9A"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.9479,
    y: 58.2958,
    width: 71.1,
    height: 35.1,
    rx: 0.9,
    transform: "rotate(-24.6653 70.9479 58.2958)",
    stroke: "#50520A",
    strokeWidth: 1.8
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.915,
    cy: 59.5335,
    rx: 10.604,
    ry: 10.604,
    transform: "rotate(-24.6653 110.915 59.5335)",
    fill: "#B1DC7D"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.115 49.0786C111.888 46.4276 118.718 48.9588 121.37 54.7321C124.021 60.5058 121.49 67.3365 115.717 69.9881C109.943 72.6395 103.112 70.1079 100.46 64.3341C97.8092 58.5604 100.341 51.7299 106.115 49.0786Z",
    stroke: "#50520A",
    strokeWidth: 1.8
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.335 66.7255C114.35 66.7565 114.387 66.7695 114.417 66.7539C117.032 65.4112 118.149 62.2338 116.91 59.5365C116.853 59.4125 116.792 59.2916 116.727 59.1737L114.297 53.8801C114.275 53.8335 114.209 53.833 114.187 53.8793L113.17 56.0082C113.154 56.0424 113.111 56.0533 113.08 56.0309L107.755 52.1249C107.705 52.088 107.639 52.1421 107.665 52.1988L108.826 54.7277C108.83 54.7371 108.837 54.7451 108.845 54.7512L113.643 58.2706C113.673 58.293 113.717 58.2821 113.733 58.2479L114.161 57.3521C114.183 57.3059 114.249 57.3064 114.27 57.353L115.412 59.8398L115.426 59.8649C115.478 59.9575 115.526 60.053 115.572 60.1512C116.471 62.1105 115.676 64.4152 113.798 65.4157C113.769 65.4309 113.757 65.4657 113.77 65.4951L114.335 66.7255Z",
    fill: "#50520A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.522 64.9546C113.537 64.9862 113.575 64.999 113.605 64.982C114.97 64.2163 115.54 62.5178 114.875 61.0707C114.559 60.3822 114.016 59.8677 113.377 59.5764C113.374 59.5746 113.37 59.5725 113.367 59.5701L110.061 57.1449C110.01 57.108 109.944 57.1622 109.97 57.2189L111.131 59.7477C111.135 59.7571 111.142 59.7652 111.15 59.7712L112.632 60.8578C112.635 60.8607 112.64 60.863 112.644 60.8649L112.719 60.896C113.069 61.042 113.366 61.3138 113.537 61.6855C113.863 62.3958 113.611 63.2238 112.978 63.6406C112.952 63.6575 112.942 63.6904 112.954 63.7183L113.522 64.9546Z",
    fill: "#50520A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.546 63.8388C112.575 63.8304 112.607 63.8441 112.62 63.872L113.188 65.1083C113.202 65.1399 113.187 65.1773 113.154 65.1893C111.684 65.7254 110.024 65.0505 109.36 63.6035C109.044 62.915 109.007 62.168 109.203 61.4934C109.204 61.4894 109.205 61.4853 109.205 61.4811L109.52 57.3931C109.525 57.331 109.609 57.3159 109.635 57.3726L110.796 59.9014C110.801 59.9108 110.803 59.9211 110.802 59.9313L110.661 61.7629C110.66 61.7677 110.659 61.7724 110.658 61.777L110.633 61.8539C110.515 62.2148 110.528 62.617 110.699 62.9887C111.025 63.699 111.817 64.0478 112.546 63.8388Z",
    fill: "#50520A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.491 54.8814C108.495 54.8907 108.497 54.901 108.497 54.9113L108.039 60.8534C108.036 60.8911 107.999 60.9169 107.963 60.907L106.992 60.6444C106.942 60.631 106.9 60.6814 106.921 60.7279L108.209 63.5323C109.108 65.4916 111.375 66.3905 113.358 65.6177C113.388 65.6059 113.422 65.6194 113.436 65.6488L114.001 66.8792C114.015 66.9102 114.001 66.947 113.969 66.9599C111.247 68.068 108.109 66.8444 106.87 64.1471L104.27 58.4845C104.248 58.438 104.291 58.3876 104.34 58.401L106.63 59.0206C106.667 59.0305 106.704 59.0047 106.706 58.9669L107.215 52.3731C107.22 52.3109 107.304 52.2958 107.33 52.3525L108.491 54.8814Z",
    fill: "#50520A"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2761 55.9212C79.831 59.3088 78.3457 63.3156 74.9583 64.8712C74.9582 64.8712 74.9581 64.8713 74.958 64.8713L72.1416 58.7383L78.2761 55.9212Z",
    fill: "#50520A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.394 32.4456C130.95 35.8322 134.956 37.3167 138.344 35.7615L135.527 29.6289L129.394 32.4456Z",
    fill: "#50520A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4094 83.2756C86.7966 81.7204 90.8031 83.2049 92.3593 86.5915L86.2256 89.4082L83.4094 83.2756Z",
    fill: "#50520A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.477 63.1158C141.922 59.7283 143.407 55.7214 146.795 54.1658C146.795 54.1658 146.795 54.1657 146.795 54.1657L149.611 60.2988L143.477 63.1158Z",
    fill: "#50520A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.1314,
    cy: 68.7989,
    r: 4.05,
    transform: "rotate(-24.6653 90.1314 68.7989)",
    fill: "#50520A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.843,
    cy: 49.6446,
    r: 4.05,
    transform: "rotate(-24.6653 131.843 49.6446)",
    fill: "#50520A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5626_19978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 23,
    width: 90,
    height: 72
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.9805,
    y: 56.084,
    width: 80.1,
    height: 44.1,
    rx: 3.6,
    transform: "rotate(-24.6653 64.9805 56.084)",
    fill: "#C9FF9A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.9479,
    y: 58.2958,
    width: 71.1,
    height: 35.1,
    rx: 0.9,
    transform: "rotate(-24.6653 70.9479 58.2958)",
    stroke: "#50520A",
    strokeWidth: 1.8
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.115 49.0786C111.888 46.4276 118.718 48.9588 121.37 54.7321C124.021 60.5058 121.49 67.3365 115.717 69.9881C109.943 72.6395 103.112 70.1079 100.46 64.3341C97.8092 58.5604 100.341 51.7299 106.115 49.0786Z",
    fill: "#B1DC7D",
    stroke: "#50520A",
    strokeWidth: 1.8
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M114.335 66.7255C114.35 66.7565 114.387 66.7695 114.417 66.7539C117.032 65.4112 118.149 62.2338 116.91 59.5365C116.853 59.4125 116.792 59.2916 116.727 59.1737L114.297 53.8801C114.275 53.8335 114.209 53.833 114.187 53.8793L113.17 56.0082C113.154 56.0424 113.111 56.0533 113.08 56.0309L107.755 52.1249C107.705 52.088 107.639 52.1421 107.665 52.1988L108.826 54.7277C108.83 54.7371 108.837 54.7451 108.845 54.7512L113.643 58.2706C113.673 58.293 113.717 58.2821 113.733 58.2479L114.161 57.3521C114.183 57.3059 114.249 57.3064 114.27 57.353L115.412 59.8398L115.426 59.8649C115.478 59.9575 115.526 60.053 115.572 60.1512C116.471 62.1105 115.676 64.4152 113.798 65.4157C113.769 65.4309 113.757 65.4657 113.77 65.4951L114.335 66.7255Z",
    fill: "#50520A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M113.522 64.9546C113.537 64.9862 113.575 64.999 113.605 64.982C114.97 64.2163 115.54 62.5178 114.875 61.0707C114.559 60.3822 114.016 59.8677 113.377 59.5764C113.374 59.5746 113.37 59.5725 113.367 59.5701L110.061 57.1449C110.01 57.108 109.944 57.1622 109.97 57.2189L111.131 59.7477C111.135 59.7571 111.142 59.7652 111.15 59.7712L112.632 60.8578C112.635 60.8607 112.64 60.863 112.644 60.8649L112.719 60.896C113.069 61.042 113.366 61.3138 113.537 61.6855C113.863 62.3958 113.611 63.2238 112.978 63.6406C112.952 63.6575 112.942 63.6904 112.954 63.7183L113.522 64.9546Z",
    fill: "#50520A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M112.546 63.8388C112.575 63.8304 112.607 63.8441 112.62 63.872L113.188 65.1083C113.202 65.1399 113.187 65.1773 113.154 65.1893C111.684 65.7254 110.024 65.0505 109.36 63.6035C109.044 62.915 109.007 62.168 109.203 61.4934C109.204 61.4894 109.205 61.4853 109.205 61.4811L109.52 57.3931C109.525 57.331 109.609 57.3159 109.635 57.3726L110.796 59.9014C110.801 59.9108 110.803 59.9211 110.802 59.9313L110.661 61.7629C110.66 61.7677 110.659 61.7724 110.658 61.777L110.633 61.8539C110.515 62.2148 110.528 62.617 110.699 62.9887C111.025 63.699 111.817 64.0478 112.546 63.8388Z",
    fill: "#50520A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M108.491 54.8814C108.495 54.8907 108.497 54.901 108.497 54.9113L108.039 60.8534C108.036 60.8911 107.999 60.9169 107.963 60.907L106.992 60.6444C106.942 60.631 106.9 60.6814 106.921 60.7279L108.209 63.5323C109.108 65.4916 111.375 66.3905 113.358 65.6177C113.388 65.6059 113.422 65.6194 113.436 65.6488L114.001 66.8792C114.015 66.9102 114.001 66.947 113.969 66.9599C111.247 68.068 108.109 66.8444 106.87 64.1471L104.27 58.4845C104.248 58.438 104.291 58.3876 104.34 58.401L106.63 59.0206C106.667 59.0305 106.704 59.0047 106.706 58.9669L107.215 52.3731C107.22 52.3109 107.304 52.2958 107.33 52.3525L108.491 54.8814Z",
    fill: "#50520A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2761 55.9212C79.831 59.3088 78.3457 63.3156 74.9583 64.8712C74.9582 64.8712 74.9581 64.8713 74.958 64.8713L72.1416 58.7383L78.2761 55.9212Z",
    fill: "#50520A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.394 32.4456C130.95 35.8322 134.956 37.3167 138.344 35.7615L135.527 29.6289L129.394 32.4456Z",
    fill: "#50520A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4094 83.2756C86.7966 81.7204 90.8031 83.2049 92.3593 86.5915L86.2256 89.4082L83.4094 83.2756Z",
    fill: "#50520A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.477 63.1158C141.922 59.7283 143.407 55.7214 146.795 54.1658C146.795 54.1658 146.795 54.1657 146.795 54.1657L149.611 60.2988L143.477 63.1158Z",
    fill: "#50520A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.1314,
    cy: 68.7989,
    r: 4.05,
    transform: "rotate(-24.6653 90.1314 68.7989)",
    fill: "#50520A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.843,
    cy: 49.6446,
    r: 4.05,
    transform: "rotate(-24.6653 131.843 49.6446)",
    fill: "#50520A"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5626_19978)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -7.28646,
    x2: 94.944,
    y2: -7.28646,
    transform: "matrix(0.384069 -0.923306 0.9233 0.384075 93.5835 104.049)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 14.5729
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -2.91458,
    x2: 94.944,
    y2: -2.91458,
    transform: "matrix(0.384069 -0.923306 0.9233 0.384075 107.472 108.174)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 5.82917
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_5626_19978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.7505,
    y: 64.4668,
    width: 80.1,
    height: 44.1,
    rx: 3.6,
    transform: "rotate(-9.66532 84.7505 64.4668)",
    fill: "#C9FF9A"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.9421,
    y: 68.1463,
    width: 71.1,
    height: 35.1,
    rx: 0.9,
    transform: "rotate(-9.66532 89.9421 68.1463)",
    stroke: "#50520A",
    strokeWidth: 1.8
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.227,
    cy: 79.6887,
    rx: 10.604,
    ry: 10.604,
    transform: "rotate(-9.66532 128.227 79.6887)",
    fill: "#B1DC7D"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M126.296 68.3476C132.559 67.2812 138.501 71.4939 139.568 77.7568C140.635 84.0199 136.422 89.9629 130.159 91.0298C123.896 92.0965 117.953 87.8831 116.886 81.6198C115.819 75.3567 120.033 69.4143 126.296 68.3476Z",
    stroke: "#50520A",
    strokeWidth: 1.8
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_i_5626_19978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.669 87.5199C129.675 87.5535 129.708 87.5758 129.741 87.5685C132.614 86.9483 134.515 84.1682 134.017 81.2422C133.994 81.1077 133.967 80.9751 133.934 80.8445L132.956 75.1021C132.948 75.0516 132.884 75.034 132.851 75.073L131.318 76.8662C131.293 76.895 131.248 76.8943 131.225 76.8647L127.092 71.7137C127.053 71.665 126.975 71.7002 126.986 71.7616L127.453 74.5049C127.455 74.5151 127.459 74.5246 127.465 74.5326L131.189 79.1738C131.212 79.2033 131.257 79.204 131.282 79.1752L131.927 78.4207C131.96 78.3818 132.024 78.3993 132.032 78.4499L132.492 81.1475L132.499 81.1753C132.525 81.2782 132.547 81.3829 132.565 81.4895C132.927 83.615 131.562 85.6354 129.489 86.1155C129.458 86.1228 129.437 86.1533 129.442 86.1851L129.669 87.5199Z",
    fill: "#50520A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.342 85.5988C129.348 85.6331 129.382 85.6554 129.416 85.6469C130.932 85.2604 131.922 83.7672 131.654 82.1975C131.527 81.4506 131.136 80.8132 130.594 80.3664C130.591 80.3637 130.588 80.3608 130.586 80.3575L128.02 77.1593C127.981 77.1107 127.903 77.1458 127.913 77.2073L128.38 79.9505C128.382 79.9607 128.386 79.9702 128.393 79.9782L129.542 81.4112C129.545 81.4149 129.549 81.4183 129.553 81.4212L129.617 81.4706C129.917 81.7023 130.134 82.0416 130.202 82.4448C130.334 83.2153 129.876 83.9501 129.156 84.1887C129.127 84.1983 129.109 84.2275 129.114 84.2577L129.342 85.5988Z",
    fill: "#50520A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.688 84.2684C128.719 84.2679 128.746 84.2893 128.751 84.3196L128.979 85.6607C128.985 85.695 128.961 85.7272 128.926 85.7302C127.367 85.8676 125.939 84.7862 125.671 83.2165C125.544 82.4696 125.702 81.7386 126.066 81.1376C126.068 81.1341 126.07 81.1303 126.071 81.1263L127.433 77.2592C127.454 77.2004 127.54 77.2077 127.55 77.2691L128.017 80.0124C128.019 80.0225 128.018 80.0329 128.015 80.0426L127.404 81.7753C127.403 81.7798 127.401 81.7842 127.398 81.7882L127.354 81.856C127.147 82.1741 127.055 82.5659 127.124 82.9691C127.255 83.7397 127.93 84.2815 128.688 84.2684Z",
    fill: "#50520A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.09 74.5668C127.092 74.5769 127.091 74.5873 127.087 74.597L125.107 80.2181C125.094 80.2538 125.052 80.2693 125.02 80.2503L124.15 79.7452C124.105 79.7195 124.051 79.7571 124.06 79.8076L124.578 82.8498C124.94 84.9752 126.896 86.43 129.012 86.1968C129.044 86.1932 129.074 86.2151 129.079 86.247L129.306 87.5817C129.312 87.6154 129.289 87.6472 129.255 87.6514C126.338 88.0171 123.624 86.0231 123.126 83.0971L122.08 76.9545C122.071 76.904 122.125 76.8664 122.17 76.8921L124.221 78.0833C124.254 78.1023 124.296 78.0869 124.309 78.0511L126.506 71.8135C126.527 71.7547 126.612 71.762 126.623 71.8235L127.09 74.5668Z",
    fill: "#50520A"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.635 67.7514C98.2602 71.426 95.7885 74.9119 92.1139 75.5377C92.1138 75.5377 92.1137 75.5378 92.1135 75.5378L90.9805 68.8848L97.635 67.7514Z",
    fill: "#50520A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.087 58.3051C153.714 61.979 157.199 64.4499 160.874 63.8244L159.741 57.1719L153.087 58.3051Z",
    fill: "#50520A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.514 95.5017C99.1883 94.8762 102.674 97.3471 103.301 101.021L96.647 102.154L95.514 95.5017Z",
    fill: "#50520A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.752 91.5767C158.127 87.9021 160.599 84.4161 164.273 83.7903C164.273 83.7903 164.274 83.7903 164.274 83.7902L165.407 90.4434L158.752 91.5767Z",
    fill: "#50520A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.753,
    cy: 83.2579,
    r: 4.05,
    transform: "rotate(-9.66532 105.753 83.2579)",
    fill: "#50520A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.002,
    cy: 75.5528,
    r: 4.05,
    transform: "rotate(-9.66532 151.002 75.5528)",
    fill: "#50520A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5626_19978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 51,
    width: 86,
    height: 57
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7505,
    y: 64.4668,
    width: 80.1,
    height: 44.1,
    rx: 3.6,
    transform: "rotate(-9.66532 84.7505 64.4668)",
    fill: "#C9FF9A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.9421,
    y: 68.1463,
    width: 71.1,
    height: 35.1,
    rx: 0.9,
    transform: "rotate(-9.66532 89.9421 68.1463)",
    stroke: "#50520A",
    strokeWidth: 1.8
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M126.296 68.3476C132.559 67.2812 138.501 71.4939 139.568 77.7568C140.635 84.0199 136.422 89.9629 130.159 91.0298C123.896 92.0965 117.953 87.8831 116.886 81.6198C115.819 75.3567 120.033 69.4143 126.296 68.3476Z",
    fill: "#B1DC7D",
    stroke: "#50520A",
    strokeWidth: 1.8
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M129.669 87.5199C129.675 87.5535 129.708 87.5758 129.741 87.5685C132.614 86.9483 134.515 84.1682 134.017 81.2422C133.994 81.1077 133.967 80.9751 133.934 80.8445L132.956 75.1021C132.948 75.0516 132.884 75.034 132.851 75.073L131.318 76.8662C131.293 76.895 131.248 76.8943 131.225 76.8647L127.092 71.7137C127.053 71.665 126.975 71.7002 126.986 71.7616L127.453 74.5049C127.455 74.5151 127.459 74.5246 127.465 74.5326L131.189 79.1738C131.212 79.2033 131.257 79.204 131.282 79.1752L131.927 78.4207C131.96 78.3818 132.024 78.3993 132.032 78.4499L132.492 81.1475L132.499 81.1753C132.525 81.2782 132.547 81.3829 132.565 81.4895C132.927 83.615 131.562 85.6354 129.489 86.1155C129.458 86.1228 129.437 86.1533 129.442 86.1851L129.669 87.5199Z",
    fill: "#50520A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M129.342 85.5988C129.348 85.6331 129.382 85.6554 129.416 85.6469C130.932 85.2604 131.922 83.7672 131.654 82.1975C131.527 81.4506 131.136 80.8132 130.594 80.3664C130.591 80.3637 130.588 80.3608 130.586 80.3575L128.02 77.1593C127.981 77.1107 127.903 77.1458 127.913 77.2073L128.38 79.9505C128.382 79.9607 128.386 79.9702 128.393 79.9782L129.542 81.4112C129.545 81.4149 129.549 81.4183 129.553 81.4212L129.617 81.4706C129.917 81.7023 130.134 82.0416 130.202 82.4448C130.334 83.2153 129.876 83.9501 129.156 84.1887C129.127 84.1983 129.109 84.2275 129.114 84.2577L129.342 85.5988Z",
    fill: "#50520A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M128.688 84.2684C128.719 84.2679 128.746 84.2893 128.751 84.3196L128.979 85.6607C128.985 85.695 128.961 85.7272 128.926 85.7302C127.367 85.8676 125.939 84.7862 125.671 83.2165C125.544 82.4696 125.702 81.7386 126.066 81.1376C126.068 81.1341 126.07 81.1303 126.071 81.1263L127.433 77.2592C127.454 77.2004 127.54 77.2077 127.55 77.2691L128.017 80.0124C128.019 80.0225 128.018 80.0329 128.015 80.0426L127.404 81.7753C127.403 81.7798 127.401 81.7842 127.398 81.7882L127.354 81.856C127.147 82.1741 127.055 82.5659 127.124 82.9691C127.255 83.7397 127.93 84.2815 128.688 84.2684Z",
    fill: "#50520A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M127.09 74.5668C127.092 74.5769 127.091 74.5873 127.087 74.597L125.107 80.2181C125.094 80.2538 125.052 80.2693 125.02 80.2503L124.15 79.7452C124.105 79.7195 124.051 79.7571 124.06 79.8076L124.578 82.8498C124.94 84.9752 126.896 86.43 129.012 86.1968C129.044 86.1932 129.074 86.2151 129.079 86.247L129.306 87.5817C129.312 87.6154 129.289 87.6472 129.255 87.6514C126.338 88.0171 123.624 86.0231 123.126 83.0971L122.08 76.9545C122.071 76.904 122.125 76.8664 122.17 76.8921L124.221 78.0833C124.254 78.1023 124.296 78.0869 124.309 78.0511L126.506 71.8135C126.527 71.7547 126.612 71.762 126.623 71.8235L127.09 74.5668Z",
    fill: "#50520A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.635 67.7514C98.2602 71.426 95.7885 74.9119 92.1139 75.5377C92.1138 75.5377 92.1137 75.5378 92.1135 75.5378L90.9805 68.8848L97.635 67.7514Z",
    fill: "#50520A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.087 58.3051C153.714 61.979 157.199 64.4499 160.874 63.8244L159.741 57.1719L153.087 58.3051Z",
    fill: "#50520A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.514 95.5017C99.1883 94.8762 102.674 97.3471 103.301 101.021L96.647 102.154L95.514 95.5017Z",
    fill: "#50520A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.752 91.5767C158.127 87.9021 160.599 84.4161 164.273 83.7903C164.273 83.7903 164.274 83.7903 164.274 83.7902L165.407 90.4434L158.752 91.5767Z",
    fill: "#50520A"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.753,
    cy: 83.2579,
    r: 4.05,
    transform: "rotate(-9.66532 105.753 83.2579)",
    fill: "#50520A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.002,
    cy: 75.5528,
    r: 4.05,
    transform: "rotate(-9.66532 151.002 75.5528)",
    fill: "#50520A"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5626_19978)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -7.28646,
    x2: 94.944,
    y2: -7.28646,
    transform: "matrix(0.609951 -0.792441 0.792434 0.609956 99.9644 118.203)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 14.5729
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_5626_19978)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -2.91458,
    x2: 94.944,
    y2: -2.91458,
    transform: "matrix(0.609951 -0.792441 0.792434 0.609956 112.312 125.781)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 5.82917
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5626_19978",
    x: 163.15,
    y: 102.934,
    width: 46.6488,
    height: 46.5707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.296
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.296
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.475 0 0 0 0 0.26405 0 0 0 0 0.0197917 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5626_19978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5626_19978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5626_19978",
    x: 167.948,
    y: 106.447,
    width: 37.0547,
    height: 37.4064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.353709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.353709
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.478431 0 0 0 0 0.262745 0 0 0 0 0.0156863 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_5626_19978",
    x: 175.805,
    y: 112.568,
    width: 11.8599,
    height: 14.0471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.353709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.530564
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.479167 0 0 0 0 0.260931 0 0 0 0 0.0159722 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_5626_19978",
    x: 182.845,
    y: 121.449,
    width: 8.03369,
    height: 8.38105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.353709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.530564
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.479167 0 0 0 0 0.260931 0 0 0 0 0.0159722 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_5626_19978",
    x: 175.619,
    y: 114.217,
    width: 22.4868,
    height: 22.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.353709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.530564
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.479167 0 0 0 0 0.260931 0 0 0 0 0.0159722 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_5626_19978",
    x: 160.957,
    y: 104.217,
    width: 52.1777,
    height: 31.8867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76855,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_5626_19978",
    x: 166.105,
    y: 114.236,
    width: 50.4907,
    height: 27.9921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76855,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_5626_19978",
    x: 173.382,
    y: 3.52645,
    width: 52.2374,
    height: 52.1168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.62003
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.62003
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.475 0 0 0 0 0.26405 0 0 0 0 0.0197917 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5626_19978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5626_19978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_5626_19978",
    x: 179.07,
    y: 7.56641,
    width: 40.8608,
    height: 40.9841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.124731
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.124731
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_5626_19978",
    x: 188.751,
    y: 14.7148,
    width: 20.0542,
    height: 29.0656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.42889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.50055
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_5626_19978",
    x: 173.511,
    y: -1.79226,
    width: 49.2461,
    height: 49.2447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.94984,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_5626_19978",
    x: 182.851,
    y: 6.39134,
    width: 45.9371,
    height: 45.9361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.94984,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_5626_19978",
    x: 3.73965,
    y: 6.66499,
    width: 60.4875,
    height: 60.4045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.45806
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.45806
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.383333 0 0 0 0 0.358167 0 0 0 0 0.329028 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5626_19978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5626_19978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_5626_19978",
    x: 9.55469,
    y: 11.0488,
    width: 48.8594,
    height: 49.3257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.466323
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.466323
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_5626_19978",
    x: 0.44077,
    y: 12.2879,
    width: 70.4329,
    height: 34.0608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.33162,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_5626_19978",
    x: 5.2186,
    y: 26.3426,
    width: 68.9842,
    height: 28.6565,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.33162,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_5626_19978",
    x: 21.0015,
    y: 19.1738,
    width: 25.9629,
    height: 33.4194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.466323
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.699485
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_5626_19978",
    x: 22.9388,
    y: 90.5897,
    width: 41.4194,
    height: 41.4184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.15245
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15245
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.229167 0 0 0 0 0.229167 0 0 0 0 0.229167 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5626_19978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5626_19978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_5626_19978",
    x: 25.2437,
    y: 91.7422,
    width: 36.8096,
    height: 36.8086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15245
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_5626_19978",
    x: 27.1914,
    y: 93.7207,
    width: 32.9556,
    height: 33.2696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.314531
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.314531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_5626_19978",
    x: 33.8828,
    y: 98,
    width: 19.9868,
    height: 22.7051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.30489
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_5626_19978",
    x: 21.509,
    y: 97.5188,
    width: 47.733,
    height: 17.441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57265,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_5626_19978",
    x: 23.3591,
    y: 107.363,
    width: 47.2813,
    height: 13.693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57265,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_5626_19978",
    x: 63.2373,
    y: 22.3721,
    width: 94.6817,
    height: 76.9903,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.45803
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.45803
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.383333 0 0 0 0 0.358167 0 0 0 0 0.329028 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5626_19978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5626_19978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_5626_19978",
    x: 98.5083,
    y: 47.127,
    width: 24.814,
    height: 25.0383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.223831
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.223831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_i_5626_19978",
    x: 104.264,
    y: 52.1133,
    width: 13.1514,
    height: 15.4777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.223831
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.335746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_5626_19978",
    x: 72.842,
    y: 3.5026,
    width: 64.4928,
    height: 107.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64323,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_5626_19978",
    x: 94.8039,
    y: 10.987,
    width: 56.4196,
    height: 104.473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64323,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_5626_19978",
    x: 82.3872,
    y: 50.1142,
    width: 91.0938,
    height: 61.6485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.45803
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.45803
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.383333 0 0 0 0 0.358167 0 0 0 0 0.329028 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5626_19978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5626_19978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_i_5626_19978",
    x: 115.821,
    y: 67.2832,
    width: 24.812,
    height: 25.0344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.223831
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.223831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0 0.180392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_i_5626_19978",
    x: 122.079,
    y: 71.6914,
    width: 12.0181,
    height: 16.2277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.223831
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.335746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_5626_19978",
    x: 81.13,
    y: 26.7897,
    width: 84.0319,
    height: 98.6999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64323,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_5626_19978",
    x: 100.406,
    y: 39.7018,
    width: 77.1032,
    height: 93.3659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64323,
    result: "effect1_foregroundBlur_5626_19978"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5626_19978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.4356,
    height: 31.4354,
    fill: "white",
    transform: "matrix(0.965926 -0.258817 0.258822 0.965925 180.25 16.8848)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5626_19978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.5779,
    height: 28.5776,
    fill: "white",
    transform: "matrix(0.965926 -0.258817 0.258822 0.965925 182 17.8926)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitPaymentMobile);
export default __webpack_public_path__ + "static/media/split-payment-mobile.2e0e6cecfcff019cfc052fd4c30af3ab.svg";
export { ForwardRef as ReactComponent };